export interface Testimonial {
  role: 'Flight Instructor'
  location: string
  text: string
  /** true until replaced with verified customer feedback */
  isSample: boolean
}

// Placeholder copy for layout only — replace with verified customer feedback before publication
// and set isSample to false.
export const shortTestimonials: Testimonial[] = [
  {
    role: 'Flight Instructor',
    location: 'United States',
    text: 'Having the complete lesson structure already organized completely changes my preparation. I can choose the skill, review the visual progression and know exactly what I want to teach before the lesson begins.',
    isSample: true,
  },
  {
    role: 'Flight Instructor',
    location: 'United Kingdom',
    text: 'The visual explanations are the strongest part for me. Takeoffs, traffic patterns, approaches and landings become much easier to explain when the student can actually see the sequence.',
    isSample: true,
  },
  {
    role: 'Flight Instructor',
    location: 'Australia',
    text: 'The progressions, instructor cues and assessment tools give my training much more structure. I spend less time preparing and more time actually teaching.',
    isSample: true,
  },
]
